import { LinearProgress } from "@mui/material";
import { UseRecordsOptions } from "../../api/useRecords";
import { RecordsHeader } from "../../components/recordsHeader/RecordsHeader";
import { useCollection } from "../../api/useCollection";
import { Records } from "../../components/records/Records";
import { ToggleBetweenTreatmentsDisplay } from "./ToggleBetweenTreatmentsDisplay";
import { Collection } from "../../types/collections.types";
import { useStore } from "../../store/store";
import { useFields } from "../../api/useFields";
import { TreatmentsProvidedAppointments } from "../../components/treatments-provided-appointments/TreatmentsProvidedAppointments";

type SessionsListProps = {
	entity: string;
	fieldsQuery: string;
	options?: UseRecordsOptions;
};

export function Treatments({ entity, fieldsQuery, options }: SessionsListProps) {
	const { treatments } = useStore();
	const { data: collection, status: statusCollection } = useCollection(entity);
	const { status: statusFields } = useFields("treatments");

	if (treatments.view === "list") {
		if (statusCollection === "loading" || statusFields === "loading") return <LinearProgress color="secondary" />;
		if (statusCollection === "error" || statusFields === "error") return <div>error</div>;

		return (
			<Records
				entity={entity}
				fieldsQuery={fieldsQuery}
				options={options}
				heightOfHeaders={222}
				header={<TreatmentsHeader collection={collection} bellowTitle={<ToggleBetweenTreatmentsDisplay />} />}
			/>
		);
	} else {
		return (
			<TreatmentsProvidedAppointments
				heightOfHeaders={222}
				header={
					<TreatmentsHeader
						collection={collection}
						headerTitle="Tratamentos Ativos - Agendamento"
						bellowTitle={<ToggleBetweenTreatmentsDisplay />}
						hideCreateButton={true}
						hideSettingsButton={true}
						hideFiltersButton={true}
					/>
				}
			/>
		);
	}
}

type TreatmentsHeaderProps = {
	collection: Collection;
	headerTitle?: string;
	bellowTitle?: React.ReactNode;
	hideCreateButton?: boolean;
	hideSettingsButton?: boolean;
	hideFiltersButton?: boolean;
};

const TreatmentsHeader = ({ collection, headerTitle, bellowTitle, hideCreateButton, hideSettingsButton, hideFiltersButton }: TreatmentsHeaderProps) => {
	return (
		<RecordsHeader
			collection={collection}
			optionalComponents={{
				bellowTitle: bellowTitle,
				headerTitle: headerTitle,
			}}
			hideCreateButton={hideCreateButton}
			hideSettingsButton={hideSettingsButton}
			hideFiltersButton={hideFiltersButton}
		/>
	);
};
